import * as types from './mutation-types'

export default {

  [types.LOAD_OFFICE] (state, office) {
    state.offices = office
  },
}
